
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.683 3.531l-.326 1.629c3.366.651 5.972 3.637 5.972 7.22 0 3.366-2.28 6.243-5.375 7.057-.651.163-1.14-.271-1.14-1.031 0 0-.108-2.66-.054-2.66.434.597 1.14 1.031 1.9 1.031a2.294 2.294 0 002.28-2.28c0-.651-.271-1.248-.706-1.628.489-.163.815-.652.815-1.14 0-.652-.543-1.195-1.195-1.249.055-.163.055-.326.055-.543A2.896 2.896 0 0013.03 7.06c-1.194 0-2.171.706-2.66 1.683-.271-.272-.597-.38-.977-.38-.76 0-1.357.597-1.357 1.357 0 .217.054.434.163.651-.977.109-1.737.978-1.737 2.009 0 .814.488 1.466 1.14 1.846-.054.217-.109.38-.109.597 0 1.14.923 2.008 2.063 2.008.76 0 1.412-.38 1.737-1.031l-.054 2.66c-.054.76-.489 1.14-1.14 1.031-3.094-.868-5.374-3.691-5.374-7.057 0-3.094 1.954-5.754 4.668-6.84l.272.706c.108.271.325.271.488.054l1.9-2.443c.163-.217.109-.434-.163-.488L8.85 2.88c-.271-.054-.38.109-.325.38l.271.76c-3.311 1.303-5.7 4.56-5.7 8.36 0 4.94 4.017 8.957 8.957 8.957s8.957-4.017 8.957-8.957c-.054-4.397-3.148-8.034-7.328-8.849","fill":"#90C81C"}})])
          )
        }
      }
    